import PortfolioV2 from "@/components/PortfolioV2";

const Index = () => {
  return <PortfolioV2 />;
};

export default Index;
